import React from 'react';
import {useNavigate} from "react-router-dom";

const EchoUsername = ({ userId, name, accountType, onlineUsers = [] }) => {
    const isOnline = onlineUsers.includes(userId);
    const icons = {
        1: { icon: 'bi bi-patch-check-fill', color: 'text-danger', title: 'Ověřený účet' },
        2: { icon: 'bi bi-patch-check-fill', color: 'text-success', title: 'Známá osobnost' },
        //3: { icon: 'bi bi-shield-lock-fill', color: 'text-danger', title: 'Administrátor' },
        4: { icon: 'bi bi-broadcast-pin', color: 'text-danger', title: 'Oficiální Echo účet' },
    };
    const navigate = useNavigate();
    const iconData = icons[accountType];

    return (
        <strong onClick={() => navigate(`/profile/${userId}`)} style={{cursor: 'pointer'}}>
            {name}
            {iconData && (
                <i
                    className={`${iconData.icon} ${iconData.color} ms-1`}
                    title={iconData.title}
                ></i>
            )}
            {isOnline && (
                <span
                    className="ms-2"
                    title="Uživatel je online"
                    style={{
                        display: 'inline-block',
                        width: '8px',
                        height: '8px',
                        backgroundColor: '#28a745',
                        borderRadius: '50%',
                        verticalAlign: 'middle'
                    }}
                ></span>
            )}
        </strong>

    );
};

export default EchoUsername;
